import React from 'react'
import List from '@mui/material/List'
import {
  Box,
  Grid2 as Grid,
  ListSubheader,
  styled,
  Typography
} from '@mui/material'
import { alpha } from '@mui/material/styles'
import MessageBox from '../MessageBox'
import useMessageList from './useMessageList'
import { ChatMessage } from 'helpers'

const StyledList = styled(List)(() => ({
  bgcolor: 'background.paper',
  overflow: 'auto',
  maxHeight: 'calc(100vh - 298px)',
  scrollbarWidth: 'thin',
  padding: '8px 16px',
  display: 'flex',
  flexDirection: 'column-reverse'
}))

const StyledListSubheader = styled(ListSubheader)(({ theme }) => ({
  alignSelf: 'center',
  borderRadius: '8px',
  backgroundColor: theme.palette.defaultComponent.main,
  boxShadow: `0px 1px 5px ${alpha(theme.palette.text.primary, 0.2)}`,
  minWidth: '70px',
  textAlign: 'center',
  margin: '10px 0px',
  position: 'relative'
}))

interface MessageListProps {
  chatId?: string
  userId?: string
}

const MessageList: React.FC<MessageListProps> = ({ chatId, userId }) => {
  const {
    lastItemRef,
    messageList,
    currentHeader,
    lastMessageRefs,
    handleScroll,
    scrollContainerRef,
    subheaderRefs
  } = useMessageList(chatId ?? '')

  return (
    <Box style={{ position: 'relative' }} flex={1}>
      <StyledListSubheader
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-55%)',
          top: '8px',
          zIndex: 2
        }}
      >
        {currentHeader}
      </StyledListSubheader>
      <StyledList
        sx={{ flex: 1, display: 'flex' }}
        onScroll={handleScroll}
        ref={scrollContainerRef}
      >
        {messageList.map((message, index, list) => {
          if (message instanceof ChatMessage) {
            const isSender = message.sender_id == userId
            const isLastMessage =
              index == 0 ||
              (index > 0 && !(list[index - 1] instanceof ChatMessage))
            return (
              <Grid
                container
                key={`chat-${index}`}
                flexDirection={'column'}
                sx={{
                  padding: '5px 0px'
                }}
                alignItems={isSender ? 'end' : 'start'}
              >
                <MessageBox
                  ref={el => {
                    if (index === list.length - 2)
                      lastItemRef.current[0] = el as any
                    if (isLastMessage)
                      lastMessageRefs.current[message.date] = el as any
                  }}
                  data-key={isLastMessage ? message.date : undefined}
                  isSender={isSender}
                >
                  <Typography>{message.message_content}</Typography>
                </MessageBox>
                <Typography variant='caption'>{message.messageTime}</Typography>
              </Grid>
            )
          }

          return (
            <StyledListSubheader
              key={`chat-${index}`}
              data-key={message}
              ref={el => (subheaderRefs.current[message] = el)}
            >
              {message}
            </StyledListSubheader>
          )
        })}
      </StyledList>
    </Box>
  )
}

export default MessageList
